module.exports = __webpack_public_path__ + "video/700_KMSAT15_2022_Internet_Based_Attacks-WebsitesAndLinks.cfb2098f.vtt";